import Location from "../../interfaces/Location";
import LocationsResponse from "../../interfaces/LocationsResponse";
import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";

const LOCATION_API_BASE_URL = process.env.REACT_APP_LOCATION_API_BASE_URL;

const getLocation = (): Promise<Location[]> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: LOCATION_API_BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response: LocationsResponse) => {
      return response.locations;
    })
    .catch((error: string) => {
      error = "Could not retrieve locations";
      throw error;
    });
};
export { getLocation };
